// Central site content & config for the El Arca de Noé landing page

export const HOTMART_URL =
  "https://pay.hotmart.com/V107355818N?bid=1787855897493";

export const PRICE = {
  currency: "MXN",
  normal: 167,
  offer: 77,
};

export const AUTHOR = "CreativesMar";

export const SITE = {
  title: "El Arca de Noé",
  subtitle: "Coloreando las Promesas de Dios en Familia",
  ageRange: "2 a 6 años",
};

export const TRUST_ITEMS = [
  { icon: "Download", label: "Descarga inmediata" },
  { icon: "ShieldCheck", label: "Pago seguro con Hotmart" },
  { icon: "Baby", label: "Ideal para 2 a 6 años" },
  { icon: "BadgeCheck", label: "Garantía de 7 días" },
];

export const BENEFITS = [
  {
    icon: "HeartHandshake",
    title: "Tiempo de calidad, sin pantallas",
    text: "Una excusa perfecta para sentarte a su lado, desconectar del celular y compartir un momento inolvidable coloreando juntos.",
  },
  {
    icon: "Sparkles",
    title: "Cero frustraciones para sus manitas",
    text: "Dibujos de líneas limpias y simples, pensados para niños pequeños. Colorean felices y se sienten orgullosos de su trabajo.",
  },
  {
    icon: "BookOpen",
    title: "Siembra la fe de forma sencilla",
    text: "Textos cortos para leer en voz alta mientras colorean. Así aprenden cómo Dios cuidó de los animalitos, sin aburrirse.",
  },
  {
    icon: "Palette",
    title: "Desarrolla creatividad y motricidad",
    text: "Cada página fortalece su motricidad fina, su atención y su imaginación mientras vive una linda aventura.",
  },
];

export const INCLUDED = [
  "Portada brillante a todo color con letras grandes para captar su atención",
  "La historia del Arca de Noé dividida en textos cortos y sencillos",
  "Ilustraciones en blanco y negro de líneas limpias para colorear",
  "Escenas paso a paso: Dios habla a Noé, la construcción del arca y los animales",
  "Los animalitos favoritos: leones, elefantes y jirafas de dos en dos",
  "Final de esperanza con la paloma y el arcoíris (la promesa de Dios)",
  "Archivo digital (PDF) para imprimir en casa las veces que quieras",
];

export const TESTIMONIALS = [
  {
    name: "Mariana G.",
    role: "Mamá de Emma (4 años)",
    stars: 5,
    text: "Mi hija ahora me pide colorear el arca antes de dormir. Aprovechamos para hablar de Dios de una forma muy tierna. ¡Lo imprimo una y otra vez!",
  },
  {
    name: "Roberto M.",
    role: "Papá de Santi (3 años)",
    stars: 5,
    text: "Los dibujos son perfectos para su edad, no se frustra. Por fin encontramos una actividad que lo mantiene feliz y lejos de la tablet.",
  },
  {
    name: "Doña Carmen",
    role: "Abuelita de dos nietos",
    stars: 5,
    text: "Imprimo una hoja para cada uno y coloreamos juntos. Es mi momento favorito de la semana y les enseño la palabra de Dios sin que se aburran.",
  },
];

export const FAQS = [
  {
    q: "¿Para qué edades es recomendado?",
    a: "Está diseñado especialmente para niños de 2 a 6 años. Los dibujos son de líneas simples y grandes, ideales para sus primeras experiencias coloreando.",
  },
  {
    q: "¿Cómo recibo el ebook?",
    a: "Es una compra 100% digital. Justo después de pagar de forma segura en Hotmart, recibirás el acceso a tu correo para descargar el archivo PDF al instante.",
  },
  {
    q: "¿Puedo imprimirlo?",
    a: "¡Claro! Esa es la gran ventaja. Al ser digital, puedes imprimirlo en tu propia casa todas las veces que quieras. Si tu pequeño se equivoca o quiere repetir una página, solo la imprimes de nuevo.",
  },
  {
    q: "¿Funciona en tablet o celular?",
    a: "Sí, puedes verlo en cualquier dispositivo (celular, tablet o computadora). Aun así, recomendamos imprimirlo para que tu hijo disfrute de colorear con sus propias manitas.",
  },
  {
    q: "¿Necesito una cuenta en Hotmart?",
    a: "No necesitas crear nada complicado. Hotmart es una plataforma de pago segura que gestiona la compra y te envía el material a tu correo automáticamente.",
  },
  {
    q: "¿Qué pasa si no me gusta?",
    a: "Tienes una garantía total de 7 días. Si el libro no es lo que esperabas, te devolvemos el 100% de tu dinero sin preguntas. El riesgo es cero.",
  },
];
